import { useEffect, useState } from "react";
import { PromtAiService } from "../../../../services/PromtAiService";
import { useTranslation } from "react-i18next";

export default function NaturalLanguageInput({ searchConfig, setquery }) {
  const [text, setText] = useState("");
  let { t } = useTranslation();
  // const [rules, setRules] = useState([]);
  // let { t } = useTranslation();
  // useEffect(() => {
  //   let keys = Object.keys(searchConfig);
  //   if (keys.length < 1) return;
  //   let _rules = [];
  //   keys.map((key) => {
  //     let field = `# for field ${key} rules are: \n`;
  //     let operations = `# for field ${key} allowed operations are: \n  {${searchConfig[
  //       key
  //     ].operation
  //       .map((s) => s)
  //       .join("|")}}\n`;
  //     let values = `# for field ${key} allowed values are: \n {${searchConfig[
  //       key
  //     ].list
  //       .map((s) => s)
  //       .join("|")}}\n`;
  //     let examples = `# for field ${key} examples are: \n ${searchConfig[
  //       key
  //     ].examples
  //       .map((s) => `${s}`)
  //       .join("\n")}\n\n`;

  //     _rules.push(field + operations + values + examples);
  //   });
  //   setRules(_rules);
  // }, [searchConfig]);

  const onChange = (event) => {
    setText(event.target.value);
  };

  //   const generate = () => {
  //     const prompt = `You are an AI that converts natural language queries into structured queries based on the following grammar rules:

  //     Grammar Rules:
  //     - Exp = {field} {operation} {Array}
  //     - Array = {Phrase} ("," {Phrase})*
  //     - Phrase = {word}+
  //     - word = (character | white_space)+
  //     - character = (letter | digit | "_" | "-" | "+" | "#" | "." | "/")
  //     - white_space = " "

  //     ${rules.join("\n")}

  //   Use only allowed fields and values: Make sure each field is spelled exactly as in the specification.if not values  are specified for a field use any value.
  // Match operations to fields: Each field has specific allowed operations, so avoid using any operation that is not listed for that field.
  // List multiple values with commas and use semicolons between different fields.
  // Use the exact JSON structure specified in your prompt for responses, and only return the JSON string as instructed, as follows:

  // {
  //     "Queries": "technologies Must Java; yearsOfExperience Must 5; salary Must 50000; businessArea Must 1"
  // }

  // Natural Language: "${text}"
  // Structured Query:
  //     `;

  function generate() {
    PromtAiService.getQuery(text, searchConfig).then((data) => {
      setquery(data.queries + " ");
    });
  }

  return (
    <>
      {" "}
      <textarea
        className="form-control"
        onChange={onChange}
        value={text}
        style={{ height: "100%" }}
      ></textarea>
      <button
        className="app-button btn-second btn-md"
        onClick={() => setText("")}
      >
        {t("Clear")}
      </button>
      <button className="app-button btn-prime btn-md" onClick={generate}>
        {t("Generate")}
      </button>
    </>
  );
}
